"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _range = _interopRequireDefault(require("../utils/range"));

var _Spacing = _interopRequireDefault(require("../Spacing"));

var styles = function styles(theme) {
  return {
    root: {
      display: 'inline-block'
    },
    dot: {
      display: 'inline-block',
      width: theme.spacing(1),
      height: theme.spacing(1),
      backgroundColor: theme.palette.grey[400],
      borderRadius: '50%',
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5)
    },
    activeStep: {
      backgroundColor: theme.palette.primary.light
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);
/** Linear stepped progress indicator which uses dots to represent entries */

var ProgressDots = function ProgressDots(_ref) {
  var steps = _ref.steps,
      activeStep = _ref.activeStep;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_Spacing["default"], {
    className: classes.root,
    Component: "ol",
    margin: 0,
    paddingTop: 0.5,
    paddingBottom: 0.5,
    paddingLeft: 2,
    paddingRight: 2
  }, (0, _range["default"])(0, steps).map(function (step) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: step,
      className: (0, _classnames["default"])(classes.dot, (0, _defineProperty2["default"])({}, classes.activeStep, step === activeStep))
    });
  }));
};

ProgressDots.propTypes = {
  /** Set the active step (zero based index). Defines which dot is highlighted. */
  activeStep: _propTypes["default"].number.isRequired,

  /** The total steps. */
  steps: _propTypes["default"].number.isRequired
};
var _default = ProgressDots;
exports["default"] = _default;